var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _circle, _circle2, _g, _g2, _g3, _g4, _g5, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflowu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 415,
    viewBox: "0 0 520 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.96 48.5H389.04C395.093 48.5002 400 53.407 400 59.46V402.669C400 408.722 395.093 413.629 389.04 413.629H70.96C64.9069 413.629 60 408.722 60 402.669V59.46L60.0146 58.8965C60.2986 53.2921 64.7921 48.7986 70.3965 48.5146L70.96 48.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.96 48.5H389.04C395.093 48.5002 400 53.407 400 59.46V402.669C400 408.722 395.093 413.629 389.04 413.629H70.96C64.9069 413.629 60 408.722 60 402.669V59.46L60.0146 58.8965C60.2986 53.2921 64.7921 48.7986 70.3965 48.5146L70.96 48.5Z",
    stroke: "#E3E4E5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 88,
    width: 140,
    height: 13,
    rx: 4,
    fill: "url(#paint0_linear_4850_29231)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 88,
    width: 140,
    height: 13,
    rx: 4,
    fill: "url(#paint1_linear_4850_29231)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 104.274,
    width: 88.5391,
    height: 12.9718,
    rx: 3.99132,
    fill: "url(#paint2_linear_4850_29231)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 104.274,
    width: 88.5391,
    height: 12.9718,
    rx: 3.99132,
    fill: "url(#paint3_linear_4850_29231)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 128.707,
    width: 301,
    height: 13,
    rx: 4,
    fill: "url(#paint4_linear_4850_29231)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 128.707,
    width: 301,
    height: 13,
    rx: 4,
    fill: "url(#paint5_linear_4850_29231)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 147.707,
    width: 245,
    height: 13,
    rx: 4,
    fill: "url(#paint6_linear_4850_29231)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 166.707,
    width: 301,
    height: 13,
    rx: 4,
    fill: "url(#paint7_linear_4850_29231)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 185.707,
    width: 196,
    height: 13,
    rx: 4,
    fill: "url(#paint8_linear_4850_29231)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 210.167,
    width: 147.475,
    height: 147.045,
    rx: 5.01328,
    fill: "url(#paint9_linear_4850_29231)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 232.564,
    y: 210.167,
    width: 147.475,
    height: 147.045,
    rx: 5.01328,
    fill: "url(#paint10_linear_4850_29231)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 225.089,
    cy: 371.401,
    r: 2.72864,
    fill: "#575CFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.912,
    cy: 371.401,
    r: 2.72864,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4850_29231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.769,
    y: 116.486,
    width: 216,
    height: 52,
    rx: 17.1525,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.769,
    y: 116.486,
    width: 216,
    height: 52,
    rx: 17.1525,
    fill: "url(#paint11_linear_4850_29231)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.913,
    y: 118.63,
    width: 211.712,
    height: 47.7119,
    rx: 15.0085,
    stroke: "white",
    strokeWidth: 4.28813,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.769,
    y: 126.486,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#00B885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.763 134.958C313.482 134.958 314.947 134.966 315.496 134.98C316.599 135.005 317.841 135.101 318.625 135.931C318.963 136.285 319.184 136.793 319.302 137.488C319.406 138.095 319.424 138.752 319.44 139.331L319.446 139.533C319.446 139.828 319.451 140.12 319.456 140.412C319.46 140.687 319.465 140.962 319.465 141.209L319.453 141.691C319.444 141.998 319.436 142.295 319.435 142.636C319.426 143.235 319.415 143.98 319.301 144.652C319.184 145.344 318.963 145.853 318.61 146.222C318.503 146.338 318.375 146.443 318.191 146.564C318.033 146.669 317.847 146.761 317.639 146.837C317.096 147.036 316.716 147.529 316.662 148.105L316.545 149.349L314.048 147.477C313.788 147.282 313.473 147.177 313.148 147.177C311.198 147.177 308.812 147.167 308.02 147.147C306.917 147.122 305.675 147.026 304.89 146.197C304.553 145.843 304.332 145.334 304.214 144.64C304.101 143.979 304.089 143.229 304.08 142.59C304.07 141.576 304.07 140.552 304.079 139.567L304.087 139.255C304.101 138.693 304.117 138.056 304.211 137.503C304.342 136.786 304.563 136.269 304.881 135.93C305.671 135.102 306.92 135.005 308.033 134.98C308.579 134.966 310.043 134.958 311.763 134.958ZM311.763 133.458C310.185 133.458 308.608 133.465 307.996 133.481C306.683 133.51 304.991 133.641 303.795 134.896C303.163 135.568 302.881 136.432 302.736 137.234C302.6 138.027 302.6 138.86 302.58 139.523C302.57 140.547 302.57 141.581 302.58 142.605C302.59 143.257 302.6 144.1 302.736 144.893C302.872 145.696 303.163 146.559 303.805 147.232C304.991 148.487 306.683 148.617 307.986 148.647C308.793 148.667 311.214 148.677 313.148 148.677L316.736 151.367C316.865 151.464 317.018 151.513 317.173 151.513C317.275 151.513 317.378 151.492 317.475 151.448C317.718 151.337 317.883 151.096 317.912 150.825L318.155 148.246C318.457 148.135 318.748 147.995 319.021 147.814C319.264 147.653 319.497 147.473 319.711 147.242C320.353 146.569 320.644 145.706 320.78 144.903C320.916 144.1 320.926 143.267 320.936 142.615C320.936 142.143 320.955 141.721 320.965 141.239C320.965 140.667 320.946 140.105 320.946 139.533V139.493C320.926 138.84 320.917 138.027 320.78 137.234C320.644 136.432 320.353 135.568 319.711 134.895C318.525 133.641 316.833 133.51 315.53 133.48C314.918 133.465 313.34 133.458 311.763 133.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.148 140.962C309.148 141.588 308.646 142.096 308.025 142.096C307.405 142.096 306.903 141.588 306.903 140.962C306.903 140.335 307.405 139.827 308.025 139.827C308.645 139.827 309.148 140.335 309.148 140.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.891 140.962C312.891 141.588 312.389 142.096 311.769 142.096C311.149 142.096 310.646 141.588 310.646 140.962C310.646 140.335 311.149 139.827 311.769 139.827C312.389 139.827 312.891 140.335 312.891 140.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.635 140.962C316.635 141.588 316.132 142.096 315.512 142.096C314.892 142.096 314.39 141.588 314.39 140.962C314.39 140.335 314.892 139.827 315.512 139.827C316.132 139.827 316.635 140.335 316.635 140.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.769,
    y: 136.941,
    width: 146,
    height: 11.0881,
    rx: 5.54407,
    fill: "#CFD4DA",
    fillOpacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4850_29231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.769,
    y: 176.486,
    width: 216,
    height: 52,
    rx: 17.1525,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.769,
    y: 176.486,
    width: 216,
    height: 52,
    rx: 17.1525,
    fill: "url(#paint12_linear_4850_29231)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.913,
    y: 178.63,
    width: 211.712,
    height: 47.7119,
    rx: 15.0085,
    stroke: "white",
    strokeWidth: 4.28813,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.769,
    y: 186.486,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#2C2E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.005 205.075C308.464 205.075 307.943 204.847 307.563 204.439L306.203 202.979C305.929 202.683 305.935 202.211 306.218 201.925C306.501 201.639 306.954 201.645 307.229 201.94L308.589 203.4C308.751 203.574 308.943 203.591 309.039 203.583C309.139 203.577 309.326 203.539 309.466 203.347L313.376 198.039C313.616 197.713 314.064 197.651 314.379 197.902C314.692 198.152 314.75 198.621 314.51 198.947L310.6 204.256C310.245 204.739 309.705 205.036 309.122 205.071C309.083 205.074 309.044 205.075 309.005 205.075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.685 209.75C321.139 208.874 320.128 208.194 318.874 207.867L318.749 207.851C318.639 207.851 318.53 207.886 318.433 207.942C318.067 208.154 317.646 208.276 317.198 208.276C317.011 208.276 316.818 208.255 316.623 208.21C316.375 208.153 316.143 208.056 315.931 207.929C315.831 207.869 315.719 207.833 315.606 207.833L315.484 207.848C314.213 208.171 313.176 208.854 312.605 209.732C312.467 209.942 312.469 210.217 312.606 210.428C313.246 211.416 314.478 212.152 315.985 212.394C316.373 212.456 316.755 212.486 317.127 212.486C319.154 212.486 320.895 211.609 321.684 210.349C321.797 210.17 321.797 209.929 321.685 209.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.815 209.174C311.897 209.048 312.008 208.94 312.104 208.822C310.747 208.854 309.725 208.854 308.319 208.816C306.885 208.781 305.269 208.658 304.231 207.631C303.26 206.671 303.229 205.005 303.202 203.535L303.199 199.476L303.202 199.297C303.229 197.827 303.26 196.16 304.231 195.191C305.268 194.166 306.885 194.042 308.321 194.006C309.064 193.986 309.699 193.976 310.333 193.976C310.968 193.976 311.603 193.986 312.348 194.006C313.782 194.041 315.399 194.165 316.436 195.191C317.327 196.073 317.43 197.531 317.46 199.075V200.754C317.61 200.769 317.759 200.772 317.907 200.806C318.259 200.886 318.588 201.028 318.89 201.212V199.052C318.863 197.636 318.82 195.494 317.421 194.11C316.082 192.785 314.208 192.561 312.383 192.516C310.868 192.475 309.799 192.476 308.286 192.516C306.459 192.561 304.585 192.785 303.244 194.112C301.842 195.511 301.803 197.595 301.773 199.269L301.769 203.387L301.773 203.564C301.803 205.238 301.842 207.323 303.246 208.713C304.586 210.039 306.46 210.262 308.284 210.307C309.041 210.327 309.688 210.337 310.333 210.337C310.737 210.337 311.152 210.332 311.583 210.324C311.524 209.93 311.59 209.521 311.815 209.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.555 206.888C316.749 206.933 316.942 206.955 317.129 206.955C318.706 206.955 319.943 205.443 319.581 203.733C319.373 202.754 318.642 201.992 317.703 201.776C317.509 201.731 317.316 201.71 317.129 201.71C315.552 201.71 314.315 203.221 314.677 204.931C314.885 205.91 315.615 206.672 316.555 206.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.769,
    y: 196.941,
    width: 146,
    height: 11.0881,
    rx: 5.54407,
    fill: "#CFD4DA",
    fillOpacity: 0.9
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4850_29231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.769,
    y: 236.486,
    width: 216,
    height: 52,
    rx: 17.1525,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.769,
    y: 236.486,
    width: 216,
    height: 52,
    rx: 17.1525,
    fill: "url(#paint13_linear_4850_29231)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.913,
    y: 238.63,
    width: 211.712,
    height: 47.7119,
    rx: 15.0085,
    stroke: "white",
    strokeWidth: 4.28813,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.769,
    y: 246.486,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#804680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.494 256.246C321.284 255.776 320.954 255.376 320.544 255.076C320.044 254.706 319.434 254.486 318.764 254.486H304.774C304.084 254.486 303.444 254.726 302.944 255.116C302.544 255.416 302.224 255.826 302.014 256.296C301.864 256.666 301.774 257.066 301.774 257.486V267.486C301.774 269.146 303.114 270.486 304.774 270.486H318.764C320.424 270.486 321.764 269.146 321.764 267.486V257.486C321.764 257.046 321.664 256.626 321.494 256.246ZM304.774 255.986H318.764C318.857 255.986 318.945 256.012 319.034 256.029L312.234 260.326C311.954 260.506 311.594 260.506 311.314 260.336L304.431 256.043C304.543 256.016 304.656 255.986 304.774 255.986ZM320.264 267.486C320.264 268.316 319.594 268.986 318.764 268.986H304.774C303.944 268.986 303.274 268.316 303.274 267.486V257.486C303.274 257.367 303.295 257.242 303.326 257.115L310.514 261.606C310.894 261.846 311.324 261.956 311.764 261.956C312.204 261.956 312.644 261.836 313.034 261.596L320.194 257.068C320.235 257.207 320.264 257.346 320.264 257.486L320.264 267.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.769,
    y: 256.941,
    width: 146,
    height: 11.0881,
    rx: 5.54407,
    fill: "#CFD4DA",
    fillOpacity: 0.9
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4850_29231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.769,
    y: 296.486,
    width: 216,
    height: 52,
    rx: 17.1525,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.769,
    y: 296.486,
    width: 216,
    height: 52,
    rx: 17.1525,
    fill: "url(#paint14_linear_4850_29231)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.913,
    y: 298.63,
    width: 211.712,
    height: 47.7119,
    rx: 15.0085,
    stroke: "white",
    strokeWidth: 4.28813,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.769,
    y: 306.486,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#575CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.382 321.298C320.356 319.564 320.356 317.373 319.04 316.031C318.074 315.046 316.763 314.703 315.425 314.579V313.677C315.425 313.263 315.089 312.927 314.675 312.927C314.261 312.927 313.925 313.263 313.925 313.677V314.509C313.211 314.493 312.495 314.483 311.778 314.483C311.055 314.483 310.333 314.493 309.613 314.509V313.677C309.613 313.263 309.277 312.927 308.863 312.927C308.448 312.927 308.113 313.263 308.113 313.677V314.585C306.781 314.714 305.478 315.051 304.517 316.031C303.465 317.093 303.256 318.692 303.194 320.173C303.186 320.217 303.168 320.256 303.168 320.302C303.168 320.333 303.182 320.359 303.186 320.39C303.176 320.705 303.168 321.016 303.162 321.311C303.137 322.615 303.137 323.919 303.162 325.223C303.187 326.958 303.187 329.149 304.504 330.491C305.77 331.782 307.632 331.972 309.366 332.01C310.22 332.03 311.074 332.043 311.927 332.043C312.669 332.043 313.411 332.034 314.152 332.01C315.887 331.959 317.748 331.782 319.014 330.491C320.331 329.149 320.319 326.958 320.357 325.223C320.357 324.628 320.382 324.046 320.382 323.451H320.395C320.395 322.729 320.395 322.02 320.382 321.298ZM308.113 316.094V316.584C308.113 316.998 308.448 317.334 308.863 317.334C309.277 317.334 309.613 316.998 309.613 316.584V316.009C310.333 315.993 311.055 315.983 311.778 315.983C312.494 315.983 313.21 315.993 313.925 316.009V316.584C313.925 316.998 314.261 317.334 314.675 317.334C315.089 317.334 315.425 316.998 315.425 316.584V316.087C316.509 316.202 317.369 316.469 317.969 317.082C318.52 317.644 318.73 318.576 318.815 319.551H304.735C304.82 318.567 305.027 317.648 305.588 317.081C306.178 316.479 307.015 316.214 308.113 316.094ZM318.882 323.451C318.882 323.737 318.876 324.021 318.87 324.305C318.863 324.61 318.856 324.915 318.857 325.19L318.852 325.417C318.822 326.899 318.787 328.58 317.943 329.441C317.138 330.262 315.879 330.459 314.105 330.511C313.412 330.533 312.7 330.543 311.927 330.543C311.085 330.543 310.244 330.53 309.399 330.51C307.697 330.473 306.395 330.277 305.575 329.44C304.709 328.558 304.684 326.765 304.664 325.325L304.662 325.194C304.637 323.915 304.637 322.619 304.662 321.344L304.666 321.119C304.667 321.096 304.668 321.074 304.668 321.051H318.878C318.878 321.099 318.88 321.15 318.88 321.197L318.882 321.325C318.894 321.972 318.894 322.609 318.895 323.255C318.886 323.319 318.882 323.384 318.882 323.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.305 322.967H306.904C306.743 322.967 306.612 323.097 306.612 323.258V324.66C306.612 324.821 306.743 324.951 306.904 324.951H308.305C308.466 324.951 308.597 324.821 308.597 324.66V323.258C308.597 323.097 308.466 322.967 308.305 322.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.232 322.967H316.634C316.795 322.967 316.925 323.097 316.925 323.258V324.66C316.925 324.821 316.795 324.951 316.634 324.951H315.232C315.071 324.951 314.941 324.821 314.941 324.66V323.258C314.941 323.097 315.071 322.967 315.232 322.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.068 322.967H312.47C312.631 322.967 312.761 323.097 312.761 323.258V324.66C312.761 324.821 312.631 324.951 312.47 324.951H311.068C310.907 324.951 310.776 324.821 310.776 324.66V323.258C310.776 323.097 310.907 322.967 311.068 322.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.305 326.493H306.904C306.743 326.493 306.612 326.624 306.612 326.785V328.186C306.612 328.347 306.743 328.478 306.904 328.478H308.305C308.466 328.478 308.597 328.347 308.597 328.186V326.785C308.597 326.624 308.466 326.493 308.305 326.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.232 326.493H316.634C316.795 326.493 316.925 326.624 316.925 326.785V328.186C316.925 328.347 316.795 328.478 316.634 328.478H315.232C315.071 328.478 314.941 328.347 314.941 328.186V326.785C314.941 326.624 315.071 326.493 315.232 326.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.068 326.493H312.47C312.631 326.493 312.761 326.624 312.761 326.785V328.186C312.761 328.347 312.631 328.478 312.47 328.478H311.068C310.907 328.478 310.776 328.347 310.776 328.186V326.785C310.776 326.624 310.907 326.493 311.068 326.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.769,
    y: 316.941,
    width: 146,
    height: 11.0881,
    rx: 5.54407,
    fill: "#CFD4DA",
    fillOpacity: 0.9
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_4850_29231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.24268,
    y: 182,
    width: 80,
    height: 52,
    rx: 17.1525,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.24268,
    y: 182,
    width: 80,
    height: 52,
    rx: 17.1525,
    fill: "url(#paint15_linear_4850_29231)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.38674,
    y: 184.144,
    width: 75.7119,
    height: 47.7119,
    rx: 15.0085,
    stroke: "white",
    strokeWidth: 4.28813,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.2427,
    y: 192,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#575CFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4850_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7802 207.084L38.1362 199.824C37.0923 198.835 35.394 198.835 34.3491 199.824L26.7051 207.084C26.4048 207.369 26.3926 207.844 26.6778 208.145C26.8253 208.3 27.0235 208.378 27.2217 208.378C27.4072 208.378 27.5933 208.31 27.7383 208.172L28.1362 207.794V215.134C28.1362 216.117 28.9214 216.918 29.8862 216.918H32.9829C33.9477 216.918 34.7329 216.117 34.7329 215.134V212.937H37.7529V215.134C37.7529 216.117 38.5381 216.918 39.5029 216.918H42.5991C43.5639 216.918 44.3491 216.117 44.3491 215.134V207.794L44.747 208.172C45.0468 208.455 45.5214 208.444 45.8075 208.145C46.0927 207.844 46.0804 207.369 45.7802 207.084Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_4850_29231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.2427,
    y: 202.811,
    width: 10,
    height: 10.3779,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.7427,
    y: 203.311,
    width: 9,
    height: 9.37789,
    rx: 4.5,
    stroke: "#575CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.2427,
    y: 204.811,
    width: 6,
    height: 6.22674,
    rx: 3,
    fill: "#575CFF"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4229 207.32C89.0473 207.32 88.7429 207.624 88.7429 208C88.7429 208.376 89.0473 208.68 89.4229 208.68V208V207.32ZM279.07 262.966C279.336 262.701 279.336 262.27 279.07 262.005L274.743 257.677C274.477 257.412 274.046 257.412 273.781 257.677C273.515 257.943 273.515 258.373 273.781 258.639L277.628 262.486L273.781 266.332C273.515 266.598 273.515 267.028 273.781 267.294C274.046 267.559 274.477 267.559 274.743 267.294L279.07 262.966ZM89.4229 208V208.68H160.006V208V207.32H89.4229V208ZM184.006 232H183.326V238.486H184.006H184.686V232H184.006ZM208.006 262.486V263.166H278.589V262.486V261.806H208.006V262.486ZM184.006 238.486H183.326C183.326 252.116 194.376 263.166 208.006 263.166V262.486V261.806C195.127 261.806 184.686 251.365 184.686 238.486H184.006ZM160.006 208V208.68C172.885 208.68 183.326 219.121 183.326 232H184.006H184.686C184.686 218.37 173.636 207.32 160.006 207.32V208Z",
    fill: "#00E2A4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4850_29231",
    x: 276.052,
    y: 115.056,
    width: 227.435,
    height: 63.435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28813
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85876
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_29231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_29231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4850_29231",
    x: 276.052,
    y: 175.056,
    width: 227.435,
    height: 63.435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28813
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85876
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_29231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_29231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4850_29231",
    x: 276.052,
    y: 235.056,
    width: 227.435,
    height: 63.435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28813
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85876
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_29231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_29231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4850_29231",
    x: 276.052,
    y: 295.056,
    width: 227.435,
    height: 63.435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28813
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85876
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_29231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_29231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_4850_29231",
    x: 0.525164,
    y: 180.571,
    width: 91.435,
    height: 63.435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28813
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85876
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_29231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_29231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_4850_29231",
    x: 59.2427,
    y: 200.811,
    width: 16,
    height: 16.3779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_29231"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4850_29231",
    result: "effect2_dropShadow_4850_29231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4850_29231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4850_29231",
    x1: 266.807,
    y1: 94.5001,
    x2: 79.5,
    y2: 94.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4850_29231",
    x1: 171.235,
    y1: 94.5001,
    x2: 42.6305,
    y2: 94.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4850_29231",
    x1: 197.957,
    y1: 110.76,
    x2: 79.5,
    y2: 110.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4850_29231",
    x1: 137.515,
    y1: 110.76,
    x2: 56.1829,
    y2: 110.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4850_29231",
    x1: 482.211,
    y1: 135.207,
    x2: 79.5,
    y2: 135.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4850_29231",
    x1: 276.73,
    y1: 135.207,
    x2: 0.230469,
    y2: 135.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4850_29231",
    x1: 407.288,
    y1: 154.207,
    x2: 79.5,
    y2: 154.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4850_29231",
    x1: 276.73,
    y1: 173.207,
    x2: 0.230469,
    y2: 173.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4850_29231",
    x1: 341.73,
    y1: 192.207,
    x2: 79.5,
    y2: 192.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4850_29231",
    x1: 153.237,
    y1: 210.167,
    x2: 153.237,
    y2: 309.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4850_29231",
    x1: 306.302,
    y1: 210.167,
    x2: 306.302,
    y2: 309.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4850_29231",
    x1: 389.769,
    y1: 168.486,
    x2: 389.769,
    y2: 116.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4850_29231",
    x1: 389.769,
    y1: 228.486,
    x2: 389.769,
    y2: 176.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4850_29231",
    x1: 389.769,
    y1: 288.486,
    x2: 389.769,
    y2: 236.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4850_29231",
    x1: 389.769,
    y1: 348.486,
    x2: 389.769,
    y2: 296.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4850_29231",
    x1: 46.2427,
    y1: 234,
    x2: 46.2427,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EAEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4850_29231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24.2427 196)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowu);
export default __webpack_public_path__ + "static/media/workflowu.2093f7893487694e099fbc84f2c9205d.svg";
export { ForwardRef as ReactComponent };